import axios from "axios"

export function request(config){
  // 创建axios实例
  const instance = axios.create({
    baseURL:"/getWx.php"    // 打包地址：http://zwfw.ryzy.vip/getWx.php
    // baseURL:"/getWx"    // 打包地址：http://www.ryzy.vip/getWx.php
  })
  // 发送真正的网络请求
  return instance(config)
}